import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FeeService {

constructor(private http: HttpClient) { }

getFees(institutionid: number): Observable<any> {
  const toYear = 2060;
  return this.http.get<any>(environment.apiUrl + 'Fee/GetFees/' + institutionid + '/1900/2060');
}

addFee(fee: any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };
  // tslint:disable-next-line:max-line-length
  return this.http.post<any>(environment.apiUrl + 'Fee/addFee', fee, httpOptions);
}

getPaidFees(institutionid: number, year: number) {
  return this.http.get<any>(environment.apiUrl + 'Fee/GetPaidFees/' + institutionid + '/' + year);
}

GetPaidFeesCSV(institutionId: number, year: number) {
  return this.http.get<any>(environment.apiUrl + 'Fee/GetPaidFeesCSV/' + institutionId +'/' + year);
}

getMemberFees(institutionid: number, year: number) {

  return this.http.get<any>(environment.apiUrl + 'Fee/GetMemberFees/' + institutionid + '/' + year);
}

addPaidFee(feedata: any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };
  // tslint:disable-next-line:max-line-length
  return this.http.post<any>(environment.apiUrl + 'Fee/addPaidFee', feedata, httpOptions);
}

  GetMemberPaidFees(roleid: number, memberid: number) {

    return this.http.get<any>(environment.apiUrl + 'Fee/GetMemberPaidFees/' + roleid + '/'+ memberid);
  /*  return this.http.get<any>(environment.apiUrl + 'Fee/GetMemberPaidFees/' + memberid, {
      responseType: "json", headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    });*/
}

  GetTotalBalanceUntilYear(memberId: number, institutionId: number, year: number) {
    return this.http.get<any>(environment.apiUrl + 'Fee/GetTotalBalanceUntilYear/' + memberId + '/' + institutionId + '/' + year);
  }

AddMemberFee(feedata: any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };
  // tslint:disable-next-line:max-line-length
  return this.http.post<any>(environment.apiUrl + 'Fee/AddMemberFee', feedata, httpOptions);
}

UserHasFeeDiscount(discountdata: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    // tslint:disable-next-line:max-line-length
    return this.http.post<any>(environment.apiUrl + 'Fee/UserHasFeeDiscount', discountdata, httpOptions);

  }


}
